const { RX } = require('../../RX/RX')
const { is } = require('../../is/is')

/**
 * A megadott paraméter valid semver?
 * @param {any} [semver] - A paraméter.
 * @returns {boolean} Valid semver?
 */
module.exports.isValid = function isValid (semver) {
  if (!is.string(semver)) {
    return false
  }

  // https://regexr.com/39s32
  return new RegExp(RX.SEMVER_STRICT).test(semver)
}
